import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  pair: string;
  timeframe: string;
  exchange: string;
  market: string;
}

/** Lightweight loading placeholder mirroring the panel's section rhythm. */
export function Skeleton({ pair, timeframe, exchange, market }: SkeletonProps) {
  return (
    <div className="skeleton">
      <div className="price-hero">
        <div className="hero-row1">
          <span className="pmeta">
            {exchange} · {market}
          </span>
          <div className="pills-row">
            <span className="sk-pill">{pair}</span>
            <span className="sk-pill">{timeframe}</span>
          </div>
        </div>
        <div className="hero-row2">
          <div className="sk-box sk-price" />
          <div className="sk-box sk-tag" />
        </div>
      </div>

      <div className="chart-section">
        <div className="sk-box sk-chart pulse" />
      </div>

      <div className="section">
        <div className="sk-box sk-card pulse" />
        <div className="sk-box sk-card pulse" />
        <div className="sk-box sk-card pulse" />
      </div>
    </div>
  );
}
